module.exports = __webpack_public_path__ + "static/media/instagram.98c57f24.svg";